var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useEffect, useRef } from 'react';
import formatUserAnswer from '../../../helpers/formatUserAnswer';
import determineCheckedAnswer from '../../../helpers/determineCheckedAnswer';
import { updateUserAnswers } from '../../../redux/userAnswers/userAnswers.slice';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { clearFormError } from '../../../redux/ui/ui.slice';
import getCurrentQuestionAnswer from '../../../helpers/getCurrentQuestionAnswer';
import AdditionalContent from '../../../ui/atoms/AdditionalContent';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { DOUBLE_CHARGE_QUESTION_ID } from '../../../const/questionIds';
import { Analytics } from '../../../helpers/analyticsMiddleware';
import Radio from './subcomponents';
import TableListQuestion from '../TableListQuestion';
var DoubleChargeContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 -", "px;\n  padding-bottom: ", "px;\n"], ["\n  margin: 0 -", "px;\n  padding-bottom: ", "px;\n"])), spacing.xlarge, spacing.base);
var RadioButton = function (_a) {
    var answer = _a.answer;
    var _b = useSelector(function (state) { return state; }, shallowEqual), _c = _b.ui, formError = _c.formError, additionalFieldFormError = _c.additionalFieldFormError, userAnswers = _b.userAnswers, currentQuestion = _b.questionnaire.currentQuestion, doubleChargeEnabled = _b.featureFlags.doubleChargeEnabled;
    var questionId = currentQuestion.id;
    var dispatch = useDispatch();
    var radioRef = useRef(null);
    var textFieldRef = useRef(null);
    var options = (answer === null || answer === void 0 ? void 0 : answer.answerOptions) || [];
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var checkedAnswer = determineCheckedAnswer({
        currentQuestion: currentQuestion,
        currentQuestionAnswer: currentQuestionAnswer
    });
    var selectedAnswer = options.find(function (item) { return item.answerOption === checkedAnswer; });
    var hasAdditionalContent = selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.additionalContent;
    var handleOnChange = function (option, nextQuestionId, answerId, disputeReason, script) {
        dispatch(clearFormError());
        var userAnswer = formatUserAnswer({
            nextQuestionId: nextQuestionId,
            answerId: answerId,
            option: [option],
            currentQuestion: currentQuestion,
            disputeReason: disputeReason,
            script: script,
            type: 'RADIOBUTTON'
        });
        dispatch(updateUserAnswers(userAnswer));
    };
    var radioButtons = options.map(function (_a, index) {
        var nextQuestionId = _a.nextQuestionId, answerId = _a.answerId, answerOption = _a.answerOption, disputeReason = _a.disputeReason, script = _a.script;
        var radioKey = index + nextQuestionId;
        var dataAnalytics = doubleChargeEnabled && questionId === DOUBLE_CHARGE_QUESTION_ID
            ? {
                dataType: Analytics.DisputeTransaction,
                dataReason: answerOption.toLowerCase(),
                dataAnalytics: 'clicktrackingevent',
                dataObject: 'radio button'
            }
            : {};
        return (_createElement(Radio, __assign({}, dataAnalytics, { "aria-checked": answerOption === checkedAnswer, "aria-label": answerOption, hasError: formError.length > 0, key: radioKey, id: answerOption, name: "recognize-charge", checked: answerOption === checkedAnswer, value: answerOption, onChange: function () {
                handleOnChange(answerOption, nextQuestionId, answerId, disputeReason, script);
            } }), answerOption));
    });
    useEffect(function () {
        var _a;
        if (additionalFieldFormError) {
            (_a = textFieldRef === null || textFieldRef === void 0 ? void 0 : textFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else if (formError) {
            radioRef.current.focus();
        }
    }, [formError, additionalFieldFormError]);
    return (_jsxs(_Fragment, { children: [doubleChargeEnabled && questionId === DOUBLE_CHARGE_QUESTION_ID && (_jsx(DoubleChargeContainer, { children: _jsx(TableListQuestion, {}) })), _jsx("div", __assign({ role: "radiogroup", ref: radioRef, tabIndex: -1, "aria-labelledby": "disputes-label", "aria-invalid": !!formError, "aria-required": "true" }, { children: radioButtons })), hasAdditionalContent && (_jsx(AdditionalContent, { textfieldRef: textFieldRef, answerMetadata: selectedAnswer.metadata }))] }));
};
export default RadioButton;
var templateObject_1;
//# sourceMappingURL=index.js.map